import dayjs from "dayjs";
import TextBox from "../shared/text-box";
import CheckboxIcon from "../ui/icons/CheckboxIcon";
import CheckedCheckboxIcon from "../ui/icons/CheckedCheckboxIcon";
import { Text } from "../ui/text";
import TypeTag from "../job-status/type-tag";
import { JobStatusTableData } from "@/types/job-status";
import AttachIcon from "../ui/icons/AttachIcon";

type Props = {
  tableData: JobStatusTableData[];
  handleSelectJob: (job: JobStatusTableData) => void;
  selectedJob: JobStatusTableData | null;
};

const TABLE_HEAD = [
  "Analysis Name",
  "Date",
  "Searched",
  "Parameter",
  "Job Note",
];

const JobSelectTable = ({ tableData, handleSelectJob, selectedJob }: Props) => {
  const getRowClass = (index: number, row: JobStatusTableData) => {
    if (selectedJob?.analysisNo === row.analysisNo) {
      return "bg-primary-99";
    }
    return index % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]";
  };

  const isSelected = (row: JobStatusTableData) => {
    return selectedJob?.analysisNo === row.analysisNo;
  };

  return (
    <table className="w-full min-w-[1050px]">
      <thead>
        <tr className="h-[50px] border-b">
          <td className="px-[16px] text-center w-[72px]">
            {/* 단일 선택이므로 전체 선택 체크박스 제거, 빈 공간 유지 */}
          </td>
          {TABLE_HEAD.map((head, index) => (
            <td key={index} className={`text-start px-[24px]`}>
              <Text variant={"title-md"} className="text-grey-40">
                {head}
              </Text>
            </td>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData?.map((row, index) => (
          <tr
            key={row.id}
            className={`text-center h-[50px] ${getRowClass(
              index,
              row
            )} hover:bg-primary-99 cursor-pointer`}
            onClick={() => handleSelectJob(row)}
          >
            <td className="px-[16px]">
              <div
                className="w-[40px] h-[40px] flex justify-center items-center cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectJob(row);
                }}
              >
                {!isSelected(row) ? <CheckboxIcon /> : <CheckedCheckboxIcon />}
              </div>
            </td>

            <td className="px-[16px] text-start">
              <div className="flex items-center gap-2">
                <Text variant={"body-md"} className="w-[165px]">
                  {row.analysisNo.split("").map((text, idx) => (
                    <TextBox
                      key={idx}
                      defaultColor={row.step === 0 ? "#666" : "#333"}
                      accentColor={row.step === 0 ? "#B2B2B2" : "#808080"}
                      condition={(idx + 1) % 6 === 0}
                    >
                      {text}
                    </TextBox>
                  ))}
                </Text>
                {["FILEUPLOAD", "RESEARCH", "REANALYSIS_COMBINE"].includes(
                  row.jobPlanDTO.executeType
                ) && <TypeTag excuteType={row.jobPlanDTO.executeType} />}
              </div>
            </td>
            <td className="w-[196px] px-[20px]">
              <Text variant={"body-md"} className="whitespace-nowrap">
                {dayjs(row.startedAt).format("YYYY-MM-DD HH:mm:ss")}
              </Text>
            </td>
            <td className="w-[80px]">
              <Text variant={"body-md"}>{row.dataType}</Text>
            </td>
            <td className="w-[160px] px-[16px]">
              <Text variant={"body-md"}>
                {row.jobPlanDTO.optionSearchParam}
              </Text>
            </td>
            <td className="w-[364px] px-[24px]">
              <div className="flex justify-between items-center">
                <Text variant={"body-md"}>time-course study</Text>
                <div className="w-[40px] h-[40px] flex justify-center items-center">
                  <AttachIcon />
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default JobSelectTable;
